import { useCreateEntityApi } from '@/common/api/createEntityApi';
import type { Package } from 'shared/packages/domain/package';
import type { PackageContent } from 'shared/packages/domain/packageContent';
import type { PackageStatus } from 'shared/packages/domain/packageStatus';
import { usePackageStore } from 'shared/packages/stores/packageStore';

export interface CreatePackage {
  number: string;
  externalNumber: string | null;
  status: PackageStatus;
  statusValidFrom: string | null;
  statusValidTo: string | null;
  packageTypeId: string | null;
  piecesCount?: number | null;
  layers?: number | null;
  piecesPerLayer?: number | null;
  spacerHeight?: number | null;
  packageStorageAreaId?: string | null;
  stackLevel?: number | null;
  occupiedStoragePlaceIds?: string[];
  nominalWeight?: number | null;
  weight?: number | null;
  nominalHeight?: number | null;
  height?: number | null;
  nominalWidth?: number | null;
  width?: number | null;
  nominalLength?: number | null;
  length?: number | null;
  longitude?: number | null;
  latitude?: number | null;
  rotation?: number | null;
  comment: string | null;
  contents: PackageContent[];
}

export interface CreatePackageResponse {
  ok: true;
  package: Package;
}

export function useCreatePackage() {
  const store = usePackageStore();

  return useCreateEntityApi<CreatePackage, CreatePackageResponse>({
    url: 'package',
    translate: (t) => t.packages.actions.create,
    async processOk(response) {
      const json = await response.json() as Package;
      store.add(json);
      return {
        ok: true,
        package: json,
      };
    },
  });
}
